var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('div',{staticClass:"head",attrs:{"slot":"main-header"},slot:"main-header"},[_c('Header')],1),_c('router-view'),_c('div',{attrs:{"slot":"main-footer"},slot:"main-footer"},[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }